import APIService from "./API.service";
const queryString = require("query-string");

class AttendeeFieldService extends APIService {
  // Create a new attendee field
  createAttendeeField(eventId: number, params: any) {
    const query = {
      eventId: eventId,
      token: localStorage.getItem("fielddrive-token"),
    };

    return this.call.post(
      `${this.apiUrl}/attendeefields?${queryString.stringify(query)}`,
      JSON.stringify(params)
    );
  }
}

export default AttendeeFieldService;
